import { defineStore } from 'pinia';
import axios from 'axios';
import router from '../router';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: JSON.parse(localStorage.getItem('user') || 'null'),
        token: localStorage.getItem('token') || null,
        loading: false,
        error: null
    }),
    
    getters: {
        isAuthenticated: state => !!state.token,
        hasPermission: state => permission => {
            if (!state.user || !state.user.permissions) return false;
            return state.user.permissions.includes(permission);
        },
        hasRole: state => role => {
            if (!state.user || !state.user.roles) return false;
            return state.user.roles.includes(role);
        }
    },
    
    actions: {
        async login(credentials) {
            this.loading = true;
            this.error = null;
            
            try {
                const response = await axios.post('/login', credentials);
                this.setUserData(response.data);
                router.push({ name: 'dashboard' });
                return response;
            } catch (error) {
                this.error = error.response?.data?.message || 'Error al iniciar sesión';
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        async logout() {
            this.loading = true;
            
            try {
                await axios.post('/logout');
            } catch (error) {
                console.error('Error al cerrar sesión:', error);
            } finally {
                this.clearUserData();
                router.push({ name: 'login' });
                this.loading = false;
            }
        },
        
        async fetchUser() {
            this.loading = true;
            
            try {
                const response = await axios.get('/user');
                const userData = {
                    user: response.data.user,
                    roles: response.data.roles,
                    permissions: response.data.permissions
                };
                
                localStorage.setItem('user', JSON.stringify(userData));
                this.user = userData;
                return response;
            } catch (error) {
                console.error('Error al obtener datos del usuario:', error);
                if (error.response?.status === 401) {
                    this.clearUserData();
                    router.push({ name: 'login' });
                }
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        setUserData(data) {
            const userData = {
                user: data.user,
                roles: data.roles,
                permissions: data.permissions
            };
            
            this.user = userData;
            this.token = data.token;
            
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('token', data.token);
        },
        
        clearUserData() {
            this.user = null;
            this.token = null;
            
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        }
    }
});